module.exports = __webpack_public_path__ + "static/5star-mmueller-551c33aa07133c221495db7159f0c561.jpg";